// css
import '../../scss/pages/page-company.scss';

// utils
import foundation from '../_utils/foundation';
foundation();
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', () => {
	// FVフェードイン
	setTimeout(() => {
		const $$copy = document.querySelectorAll('.js-FvFeadIn');
		if ($$copy.length > 0) {
			$$copy.forEach(($copy) => {
				const $heads = $copy.querySelectorAll('.js-FvFeadIn-head');
				ScrollTrigger.create({
					trigger: $heads,
					onEnter: () => {
						$heads.forEach(($head) => {
							$head.classList.add('is-FvFeadIn');
						});
					},
				});
			});
		}
	}, 50);

	// テキストフェードインアップアニメーション
	setTimeout(() => {
		const $$copy = document.querySelectorAll('.js-TextFeadIn');
		if ($$copy.length > 0) {
			$$copy.forEach(($copy) => {
				const $heads = $copy.querySelectorAll('.js-TextFeadIn-head');
				ScrollTrigger.create({
					trigger: $heads,
					onEnter: () => {
						$heads.forEach(($head) => {
							$head.classList.add('is-TextFeadIn');
						});
					},
				});
			});
		}
	}, 50);
});

window.addEventListener('load', () => {});
